import { SerializedError } from '@reduxjs/toolkit';
import { GraphQLError } from 'graphql';
import { GraphQLError as OtherGraphQLError } from 'graphql-request/dist/types';

export enum ErrorCodes {
  UNAUTHORIZED = 'UNAUTHORIZED',
  INVALID_TOKEN = 'INVALID_TOKEN',
  INVALID_EMAIL_OR_PASSWORD = 'INVALID_EMAIL_OR_PASSWORD',
}

export function firstGraphqlError(
  error: SerializedError,
): GraphQLError | OtherGraphQLError | undefined {
  if (error?.graphQLErrors) {
    return error.graphQLErrors[0];
  }
}

export function checkUnauthorizedError(
  errors: GraphQLError[] | OtherGraphQLError[] = [],
) {
  return errors.some(
    (error) => error.extensions.code === ErrorCodes.UNAUTHORIZED,
  );
}

export function getTranslatedErrorMessage(error?: SerializedError) {
  if (!error) {
    return undefined;
  }

  const errorCode = firstGraphqlError(error)?.extensions?.code;

  switch (errorCode) {
    case 'INVALID_PERMISSIONS':
      return 'You do not have permission to perform this action.';
    case 'INVALID_TOKEN':
      return 'Invalid token';
    case 'INVALID_EMAIL_OR_PASSWORD':
      return 'Invalid email or password';
    default:
      return 'Internal Server Error';
  }
}
